import Avatar1 from '../../assets/avatar1.jpg'
import Avatar2 from '../../assets/avatar2.jpg'
import Avatar3 from '../../assets/avatar3.jpg'
import Avatar4 from '../../assets/avatar4.jpg'
import Avatar5 from '../../assets/avatar5.jpg'



const data = [
    {
        id: 1,
        quote: "Mi hija de 5 años ha logrado un avance en lectoescritura, la maestra crea un ambiente de aprendizaje entretenido, dinámico y muy positivo, lo que ha permitido que nuestra hija supere sus retos con excelente actitud.",
        avatar: Avatar1,
        name: 'Karla Gutiérrez',
        child: 'Mamá de Samantha (5 años).'
    },
    {
        id: 2,
        quote: "Tiene una forma única de conectar con los niños. Mi hija espera cada clase con emoción.",
        avatar: Avatar2,
        name: 'Ana Díaz',
        child: 'Mamá de Daniela (6 años).'
    },
    {
        id: 3,
        quote: "Tiene una forma de explicar que hace que todo parezca fácil. Mi hija está encantada.",
        avatar: Avatar3,
        name: 'Mary Rodríguez',
        child: 'Mamá de Gabriela (9 años).'
    },
    {
        id: 4,
        quote: "Cada sesión es personalizada y enfocada en resultados. ¡Totalmente recomendada!",
        avatar: Avatar4,
        name: 'Grabriela Pérez',
        child: 'Mamá de Roxana (10 años).'
    },
    {
        id: 5,
        quote: "100% recomendada, superprofesional, responsable, dedicada y planificada. Durante este año escolar mi hija aprendió a leer, escribir, tomar dictados, copias, sumas y restas.",
        avatar: Avatar5,
        name: 'Betsabe Capote',
        child: 'Mamá de Natalia (6 años)'
    },
    /*
    {
        id: 5,
        quote: "Es paciente, dedicada y muy profesional. Se nota que ama lo que hace.",
        avatar: Avatar5,
        name: 'Jesús Álvarez',
        child: 'Papá de Antonela  (8 años).'
    }*/
]



export default data